import { useState } from "react";
import RangeSlider from 'react-bootstrap-range-slider'
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css'
import { Explorer } from "../../Explorer";


export function Size({uuid,defaulValue} ) {
  const size = defaulValue ? typeof defaulValue.size !== 'undefined' ? defaulValue.size :2 : 2
  const [sizeBorder, setSizeBorder] = useState(size)
  function onChange(size){
    Explorer.changeStyle(uuid, 'size', parseInt(size ))
  }
  return (
    <>
      <div className='item-config'>
        <div className='item-config-align'>
          <div   data-bs-toggle='collapse'
              data-bs-target={`#collapseExample_${uuid}_size`}
              aria-expanded='false'
              aria-controls={`collapseExample_${uuid}_size`}>
            <div
              className='item-config-align-title'
            
            >
              Size
            </div>
            {/* <label className='switch pull-right'>
              <input type='checkbox' id='text' name='text' />
              <span className='slider round'></span>
            </label> */}
          </div>
          <div
            className='border-left-layers w-100 collapse '
            id={`collapseExample_${uuid}_size`}
          >
            <div className=''>
            <input
                        className='form-control'
                        type='text'
                        defaultValue={sizeBorder}
                        // value={sizeBorder}
                        onChange={(changeEvent) => {
                          let val = changeEvent.target.value
                          setSizeBorder( parseInt(val) );
                          onChange(val)
                        }}
                      />
              <RangeSlider
                        value={sizeBorder}
                        onChange={(changeEvent) => {
                            let val = changeEvent.target.value
                            setSizeBorder( parseInt(val) );
                            onChange(val)
                          }
                        }
                        min={1}
                        max={10}
                        step={0.5}
                      />
                     
                      
             
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
